import { localDatabaseUrls } from "../backend/constants";
import { getJWTToken } from "../shared/fetchWrapper/fetchWrapper";
import { postAPI } from "../backend/commons";
import AlertManager from "../shared/Alert/Alert";

const resolveApprovedTargetItem = (row = {}) => ({
  sku: row?.parsedSku || row?.sku || row?.skuId || row?.id || "",
  hqLine: row?.hqLine || "",
});

export const buildApproveDCCostBatchPayload = (
  selectedRows = [],
  tokenInfo = {},
  comments = "Approved selected items",
  useModifiedValues = false
) => ({
  approvedBy: tokenInfo.username || "",
  comments,
  useModifiedValues: Boolean(useModifiedValues),
  targetItems: selectedRows.map((row) => resolveApprovedTargetItem(row)),
});

export const approveDCCostBatch = async (batchId, selectedRows = [], { comments, successMessage, useModifiedValues } = {}) => {
  if (!batchId) {
    AlertManager.error("Unable to approve DC cost batch.", { contactSupport: false });
    return null;
  }

  if (!Array.isArray(selectedRows) || !selectedRows.length) {
    AlertManager.warning("Select one or more items to approve.", { contactSupport: false });
    return null;
  }

  const tokenInfo = await getJWTToken();

  if (!tokenInfo) {
    window.location.href = "/";
    return null;
  }

  const apiUrl = `${localDatabaseUrls.baseURL}api/v1/dc-cost/approve/${encodeURIComponent(batchId)}`;
  const requestBody = buildApproveDCCostBatchPayload(
    selectedRows,
    tokenInfo,
    comments || "Approved selected items",
    useModifiedValues
  );
  const body = new Blob([JSON.stringify(requestBody)], { type: "application/json" });

  try {
    const response = await postAPI(apiUrl, body, tokenInfo);

    if (response?.ok) {
      AlertManager.success(successMessage || "Selected items approved successfully.", { contactSupport: false });
      return response;
    }

    const errorData = await response?.json?.().catch(() => ({}));
    throw new Error(errorData?.message || "Unable to approve selected items.");
  } catch (error) {
    AlertManager.error(error?.message || "Unable to approve selected items.", { contactSupport: false });
    return null;
  }
};

export default approveDCCostBatch;
